import React, { useEffect, useState } from "react";
import { DefaultStoryCard } from "../../DefaultStoryCard";
import { isTemplateWithAds } from "../../../utils/story";
import { WithStoryAds } from "../../WithStoryAds";
import "./gn-reach-facts.m.css";

export default function GnReachFacts({ story, card, counter = {} }) {
  const customStoryElements = card["story-elements"];
  const showCustom = customStoryElements.every((item) => item.type === "text" && item.subtype === "bigfact");

  const componentToRender = (
    <div className="story-element story-element-gn-reach-facts" styleName="gn-reach-fact-wrapper">
      {customStoryElements?.slice(0, 3).map((item) => {
        const { content, attribution: description } = item.metadata;
        return (
          <div key={item.id} styleName="fact-box">
            <div styleName="bigfact-title">{content}</div>
            <div styleName="bigfact-description">{description}</div>
          </div>
        );
      })}
    </div>
  );

  const enableParagraphAds = isTemplateWithAds(story);
  if (!showCustom) {
    return <DefaultStoryCard card={card} story={story} counter={counter} />;
  }
  return enableParagraphAds ? (
    <WithStoryAds counter={counter} componentToRender={componentToRender} story={story} />
  ) : (
    <>{componentToRender}</>
  );
}
